<!--
 * @Author: Narcissus
 * @Date: 2022-10-25 17:38:02
 * @LastEditTime: 2022-10-25 19:11:48
 * @LastEditors: Narcissus
 * @Description:
 * @FilePath: \hi-tom\src\App.vue
-->
<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue